<template>
    <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
      <div
        class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25"
      >
        
        
      </div>
      <div class="card-body p-15 p-sm-20 p-md-25">
        <div class="col-md-12">
        <div class="row">
          <!-- <form class="row" @submit.prevent="rechercher"> -->
            
            <div class="col">
              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <label class="d-block text-black fw-semibold mb-10">
                 Mot clé
                </label>
                <Field 
                  style="max-height: 42px;"
                  v-model="searchTerm"
                  @keyup="rechercher" 
                  name="mot" 
                  type="text" 
                  aria-disabled="true"
                  class="form-control shadow-none fs-md-15 text-black" 
                  placeholder="Recherche par mot clé"/>
              </div>
            </div>
  
            <div class="col">
              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <label class="d-block text-black fw-semibold mb-10">
                  Date Debut
                </label>
                <Field name="dateDebut" type="date" v-model="_dateDebut"
                class="form-control shadow-none fs-md-15 text-black"/>
                <ErrorMessage name="dateDebut" class="text-danger"/>
              </div>
            </div>
  
            <div class="col">
              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <label class="d-block text-black fw-semibold mb-10">
                  Date Fin
                </label>
                <Field name="dateFin" type="date"  v-model="_dateFin"
                class="form-control shadow-none fs-md-15 text-black"/>
                <ErrorMessage name="dateFin" class="text-danger"/>
              </div>
            </div>
            
  
          <!-- </form> -->
        </div>
        </div>
        <hr>
        <div class="table-responsive">
          <table class="table text-nowrap align-middle mb-0">
            <thead>
              <tr>
                <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0" >
                  PRODUIT
                </th>
                <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0" >
                  QTE VENDU
                </th>
                <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0" >
                  STOCK DISPONIBLE
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(el, index) in elements" :key="index">
                <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                    {{ el.nomComplet+' [ '+ el.conditionnement.code+' ]' }}
                </td>
                <td class="shadow-none lh-1 fw-medium text-primary">
                    {{ (el.totalVendu) ? el.totalVendu : 0 }}
                </td>
                <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                  
                </td>
                
              </tr>
             
            </tbody>
          </table>
        </div>
        <div class="pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center">
          
          <PaginationComponent :page="page" :totalPages="totalPages" :totalElements="totalElements" :limit="limit" @paginate="handlePaginate" />
  
        </div>
      </div>
    </div>
  
  </template>
  
  <script lang="ts">
  import { defineComponent, onMounted, ref, watch } from "vue";
  import { Form, Field, ErrorMessage } from 'vee-validate';
  import ApiService from "@/services/ApiService";
  import { useRouter } from 'vue-router';
  import { format_date,suppression,format_Date, hideModal, showModal,separateur, error,success, getCurrentDate } from "@/utils/utils";
  import PaginationComponent from '@/components/Utilities/Pagination.vue';
  import JwtService from "@/services/JwtService";
  import Multiselect from '@vueform/multiselect';
  import axios from "axios";
  import { Reglement } from '../../models/Reglement';
  
  export default defineComponent({
      name: "PointDesReglements",
      components: {
        // Form,
        Field,
       // Multiselect,
        PaginationComponent,
    },
    setup: () => {
      
  
      const elements = ref<Array<any>>([]);
      const reglement = ref<Reglement>();
      const ResiliationRef = ref<null | HTMLElement>(null);
      const modeleOptions = ref([]);
      const agentOptions = ref([]);
      const clientOptions = ref([]);
      const venteOptions = ref([]);
      const categorieAbonneOptions = ref([]);
      const total = ref(0);

      const nooptions = "La liste est vide";
      const noResultText = "Aucun enregistrement trouvé";
      const noOptionsTextAbb = ref("Tapez au moins trois caractères");
  

  
      // BEGIN PAGINATE
      const _dateDebut = ref<string | null>(null);
      const _dateFin = ref<string | null>(null);
      const _agent = ref('');
      const _client = ref('');
      const _vente = ref('');
      const searchTerm = ref('');
      const page = ref(1);
      const totalPages = ref(0);
      const limit = ref(10);
      const totalElements = ref(0);
      const router = useRouter();
  
      const handlePaginate = ({ page_, limit_ }) => {
        try {
          page.value = page_;
          getAll(page_, limit_, searchTerm.value, _agent.value ?? undefined, _dateDebut.value ?? undefined, _dateFin.value ?? undefined);
        } catch (error) {
          //
        }
      };
     
  
      watch([_dateDebut, _dateFin, _agent, _client, _vente, searchTerm], () => {
        console.log('watching', _dateDebut, _dateFin, _agent);
        rechercher();
      });

  
      function rechercher(){
        getAll(page.value, limit.value, searchTerm.value, _agent.value ?? undefined, _dateDebut.value ?? undefined, _dateFin.value ?? undefined);
      }
  
      // END PAGINATE
      const resiliation = (id: number) => {
        //show modal
        showModal(ResiliationRef.value!);
      }

  
      const fetchAgent = async () => {
        console.log('fetching agents');
        ApiService.get("/utilisateurs/agent")
          .then(({ data }) => {
            agentOptions.value = data.data.map((p) => {
                return {
                  value: p.id,
                  label: p.nom + " " + p.prenoms,
                };
            });
          })
          .catch(({ response }) => {
          // produitsError.value = true;
          });
      };

      const fetchClient = async () => {
        ApiService.get("/clients")
            .then(({ data }) => {
            clientOptions.value = data.data.data.map((p) => {
              return {
                value: p.id,
                label: "[ "+ p.code +" ] " +p.nom + " " + p.prenoms,
              };
            });
            console.log('clients', clientOptions.value);
            })
            .catch(({ response }) => {
            // produitsError.value = true;
            });
      };

      const searchClient = async (key) => {
        try {
          const  data  = await ApiService.get("/clients/recherche/" + key);
          clientOptions.value = data.data.data.map((p) => ({
            value: p.id,
            label: "[ " + p.code + " ] " + p.nom + " " + p.prenoms,
          }));
          console.log("clients", clientOptions.value);
          // if (clientOptions.value.length == 0) {
          //   noOptionsTextAbb.value = noResultText;
          // } else {
          //   noOptionsTextAbb.value = 'Tapez au moins trois caractères';
          // }
          return clientOptions.value;
        } catch (error) {
          // produitsError.value = true;
          return [];
        }
      };

      const fetchVente = async () => {
        ApiService.get("/ventes")
            .then(({ data }) => {
              venteOptions.value = data.data.data.map((p) => {
                return {
                  value: p.id,
                  label: p.client.code+" - "+p.montant,
                };
              });
              console.log('clients', venteOptions.value);
            })
            .catch(({ response }) => {
            // produitsError.value = true;
            });
      };
  

       function getAll(page = 1, limi = 10, searchTerm = '', _produit = '', _dateDebut = '' , _dateFin = '', _categorie = '') {
        
        return ApiService.get(`/produitConditionnements/vendu?page=${page}&limit=${limi}&mot=${searchTerm}&produit=${_produit}&dateDebut=${_dateDebut}&dateFin=${_dateFin}&categorie=${_categorie}&ok`)
      .then(({ data }) => {
            elements.value = data.data.data
            totalPages.value = data.data.totalPages;
            limit.value = data.data.limit;
            totalElements.value = data.data.totalElements;
            total.value = data.data.totalReglement.totalReglement;
            console.log('reglements', total.value);
          })
          .catch(({ response }) => {
            // error(response.data.message);
          });
      }
  
      onMounted(async () => {
          console.log('mounted');
          await fetchAgent();
          await fetchClient();
          await fetchVente();
          await getAll();
          _dateDebut.value = getCurrentDate();
          _dateFin.value = getCurrentDate();
          // await getAll(page.value, limit.value, searchTerm.value, _agent.value ?? undefined, _dateDebut.value ?? undefined, _dateFin.value ?? undefined);
      });
  
    //   const addValidAbonnementModalRef = ref<null | HTMLElement>(null);
  
    //   const valideAbonnement = () => {
    //   const dataToSend = {
    //     id : selectedAbonnement?.value?.id.toString()      };
    //     console.log('data', dataToSend);
    //     ApiService.put("/valide/abonnements/"+ selectedAbonnement?.value?.id.toString(), dataToSend)
    //       .then(({ data }) => {
    //         if(data.code == 200) { 
    //           success(data.message);
    //           hideModal(addValidAbonnementModalRef.value);
    //           getAll();
    //         }
    //       }).catch(({ response }) => {
    //         error(response.data.message);
    //       });
    //   };
  
  
    //   const privileges = ref<Array<string>>(JwtService.getPrivilege());
  
    //   const checkPermission = (name) => {
    //     return privileges.value.includes(name);
    //   }

    const formatMontant = (montant) => {
      return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'XOF' }).format(montant);
    };
      
      return { 
        elements,
        // checkPermission,
        modeleOptions,
        agentOptions,
        clientOptions,
        venteOptions,
        categorieAbonneOptions,
        format_date,
        suppression,
        getAll,
        resiliation,
        // resilier,
        page, 
        totalPages,
        limit,
        format_Date,
        totalElements,
        handlePaginate,
        separateur,
        searchTerm,
        rechercher,
        Multiselect,
        getCurrentDate,
        _dateDebut,
        _dateFin,
        _agent,
        _client,
        _vente,
        total,
        formatMontant,
        searchClient,
        nooptions,
        noResultText,
        noOptionsTextAbb,
        // valideAbonnement,
        // addValidAbonnementModalRef
      };
    },
  });
  </script>
  
  